import React, { useState, useEffect } from "react";
import { getUserPhoto } from "api";
//
import { makeStyles } from "@material-ui/core";
import { Person as PersonIcon } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
    personIcon: {
        width: 220,
        height: 220,
        borderRadius: 120,
        color: theme.palette.primary.light,
    },
    avatarContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
    },
}));

export default function ProfileImage() {
    const [imageData, setImageData] = useState(null);
    const classes = useStyles();

    useEffect(() => {
        getUserPhoto()
            .then((url) => {
                setImageData(url);
            });
    }, []);

    return imageData != null ? (
        <div className={classes.avatarContainer}>
            {imageData && (
                <img className={classes.personIcon} src={`data:image/jpeg;base64,${imageData}`} alt="profile"/>
            )}
        </div>
    ) : (
        <div className={classes.avatarContainer}>
            <PersonIcon className={classes.personIcon} />
        </div>
    );
}
